import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbAuthModule, NbPasswordAuthStrategy, NbAuthOAuth2JWTToken } from '@nebular/auth';
import { HttpResponse, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';
import { of } from 'rxjs';

// *** AJOUT OBLIGATOIRE POUR NEBULAR SECURITY ***
export class SimpleRoleProvider extends NbRoleProvider {
    getRole() {
        // Ici, toujours "user". Adapte si besoin plus tard.
        return of('user');
    }
}

@NgModule({
    exports: [NbAuthModule], imports: [CommonModule,
        NbAuthModule.forRoot({
            strategies: [
                NbPasswordAuthStrategy.setup({
                    name: 'email',
                    baseEndpoint: `${environment.backendUrl}/`,
                    login: {
                        alwaysFail: false,
                        endpoint: 'api/token/',
                        method: 'post',
                        requireValidToken: true,
                        redirect: {
                            success: '/pages/dashboard',
                            failure: null,
                        },
                        defaultErrors: ['Mauvaise combinaison identifiant/mot de passe.'],
                        defaultMessages: ['You have been successfully logged in.'],
                    },
                    refreshToken: {
                        endpoint: 'api/token/refresh/',
                    },
                    requestPass: {
                        endpoint: 'api/password_custom_reset/',
                    },
                    resetPass: {
                        endpoint: 'api/password_reset/confirm/',
                    },
                    logout: false,
                    token: {
                        class: NbAuthOAuth2JWTToken,
                        getter: (module: string, res: HttpResponse<any>) => {
                            let { refresh, access: token, temp_token } = res.body;
                            if ((res.body['2fa_required'] || res.body['2fa_setup_required'] || res.body['2fa_activation_pending']) && temp_token) {
                                token = temp_token;
                            }
                            return { access_token: token, refresh_token: refresh };
                        },
                    },
                }),
            ],
            forms: {},
        }),
        NbSecurityModule.forRoot({
            accessControl: {
                guest: { view: '*' },
                user: { parent: 'guest', create: '*', edit: '*', remove: '*' }
            }
        })], providers: [
            { provide: NbRoleProvider, useClass: SimpleRoleProvider },
            provideHttpClient(withInterceptorsFromDi()),
        ]
})
export class CoreModule {
    constructor() { }
}
